import Base, { baseInit } from './base';

/**
 * Simple class for use as a DTO/Pojo type.
 */
class Pojo extends Base {
  constructor(data) {
    super(data);
    baseInit(this, data, true);
  }
}

export default Pojo;
